'use client'
import { Link } from '@heroui/react'
import { type FC, useEffect } from 'react'

interface ErrorProps {
	error: Error & { digest?: string }
	reset: () => void
}

const Error: FC<ErrorProps> = ({ error, reset }) => {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error)
	}, [error])

	return (
		<div className="flex h-screen flex-col items-center justify-center gap-2">
			<h1 className="text-4xl font-bold">Whoops, something went wrong...</h1>
			<p className="text-accent-foreground">
				An error occurred in the application. Below you can find more details:
			</p>
			<pre>{error?.message || JSON.stringify(error)}</pre>
			<p className="text-accent-foreground">
				Go back to the{' '}
				<Link href="/" className="text-sky-500 dark:text-sky-400">
					Dashboard
				</Link>
			</p>
		</div>
	)
}

export default Error
